const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(() => {
  const pillSelector = '.sl-listicle .sl-listicle__rating';

  const findReviewsTarget = () => {
    const section = document.querySelector('[id$="__snaplock_reviews"]');
    if (section) return section;

    const looxReviews = document.querySelector('#looxReviews');
    return looxReviews?.closest('.shopify-section') || looxReviews;
  };

  const scrollToReviews = () => {
    const target = findReviewsTarget();
    if (!target) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';

    target.scrollIntoView({ behavior, block: 'start' });
  };

  const enhanceReviewPills = (scope = document) => {
    scope.querySelectorAll(pillSelector).forEach((pill) => {
      if (pill.dataset.slReviewsReady === 'true') return;

      pill.dataset.slReviewsReady = 'true';
      pill.setAttribute('role', 'button');
      pill.setAttribute('tabindex', '0');
      pill.style.cursor = 'pointer';
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    enhanceReviewPills();
  });

  document.addEventListener('shopify:section:load', (event) => {
    enhanceReviewPills(event.target);
  });

  document.addEventListener('click', (event) => {
    const pill = event.target.closest?.('.sl-listicle__rating');
    if (!pill || !pill.closest('.sl-listicle')) return;

    event.preventDefault();
    scrollToReviews();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const pill = event.target.closest?.('.sl-listicle__rating');
    if (!pill || !pill.closest('.sl-listicle')) return;

    event.preventDefault();
    scrollToReviews();
  });
})();

(() => {
  const pulseClass = 'sl-kaching-cta-pulse';
  const pulseStyleId = 'SnapLockKachingCtaPulse';
  const purchaseLabels = ['buy now', 'add to cart', 'comprar ahora', 'añadir al carrito'];

  const installPulseStyles = () => {
    if (document.getElementById(pulseStyleId)) return;

    const style = document.createElement('style');
    style.id = pulseStyleId;
    style.textContent = `
      @keyframes slKachingCtaBreathe {
        0%, 72%, 100% {
          transform: scale(1);
          box-shadow: 0 8px 22px rgba(255, 90, 31, 0.22), 0 0 0 0 rgba(255, 90, 31, 0);
        }
        84% {
          transform: scale(1.006);
          box-shadow: 0 9px 24px rgba(255, 90, 31, 0.25), 0 0 0 6px rgba(255, 90, 31, 0.10);
        }
        94% {
          transform: scale(1);
          box-shadow: 0 8px 22px rgba(255, 90, 31, 0.22), 0 0 0 12px rgba(255, 90, 31, 0);
        }
      }

      body:has(.sl-listicle) .${pulseClass}:not(:disabled) {
        animation: slKachingCtaBreathe 5.2s ease-out infinite !important;
        transform-origin: center;
        will-change: transform, box-shadow;
      }

      body:has(.sl-listicle) .${pulseClass}:hover,
      body:has(.sl-listicle) .${pulseClass}:focus-visible,
      body:has(.sl-listicle) .${pulseClass}:active {
        animation: none !important;
      }

      @media (prefers-reduced-motion: reduce) {
        body:has(.sl-listicle) .${pulseClass} {
          animation: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const enhancePurchaseButtons = () => {
    if (!document.querySelector('.sl-listicle')) return;

    const hero = document.querySelector('.sl-hero');
    if (!hero) return;

    const candidates = hero.querySelectorAll(
      'kaching-bundle button, kaching-bundles-block button, .kaching-bundles button, [class*="kaching-bundles"] button, .sl-hero__button'
    );

    candidates.forEach((button) => {
      const label = button.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const isNativeButton = button.matches('.sl-hero__button');
      const isPurchaseButton = purchaseLabels.some((purchaseLabel) => label.includes(purchaseLabel));

      if (isNativeButton || isPurchaseButton) button.classList.add(pulseClass);
    });
  };

  const initializePulse = () => {
    if (!document.querySelector('.sl-listicle')) return;

    installPulseStyles();
    enhancePurchaseButtons();

    const hero = document.querySelector('.sl-hero');
    if (!hero || hero.dataset.slCtaPulseObserver === 'true') return;

    hero.dataset.slCtaPulseObserver = 'true';
    let animationFrame;

    const observer = new MutationObserver(() => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(enhancePurchaseButtons);
    });

    observer.observe(hero, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePulse);
  } else {
    initializePulse();
  }

  document.addEventListener('shopify:section:load', initializePulse);
})();
